import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { DashboardPreferencesDTORuntype, DashboardQuickActionDTORuntype } from './dashboardBackendType';

export const dashboardEndpoints = {
    'GET /dashboard/preferences': endpoint({
        description: 'Fetches the dashboard preferences for the logged-in user',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ data: DashboardPreferencesDTORuntype }),
    }),

    'PUT /dashboard/preferences': endpoint({
        description: 'Updates the dashboard preferences for the logged-in user',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: DashboardPreferencesDTORuntype,
        responseBody: z.object({ data: DashboardPreferencesDTORuntype }),
        invalidates: ['GET /dashboard/preferences', 'GET /dashboard/quick-actions'],
    }),

    'GET /dashboard/quick-actions': endpoint({
        description: 'Fetches the custom quick actions for the logged-in user',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ data: z.array(DashboardQuickActionDTORuntype) }),
    }),

    'POST /dashboard/quick-actions': endpoint({
        description: 'Creates a new custom quick action for the logged-in user',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: DashboardQuickActionDTORuntype.omit({ id: true }),
        responseBody: z.object({ data: DashboardQuickActionDTORuntype }),
        invalidates: ['GET /dashboard/preferences', 'GET /dashboard/quick-actions'],
    }),

    'PATCH /dashboard/quick-actions/:id': endpoint({
        description: 'Updates an existing custom quick action for the logged-in user',
        pathParams: z.object({ id: z.string() }),
        queryParams: z.undefined(),
        requestBody: DashboardQuickActionDTORuntype.omit({ id: true }),
        responseBody: z.object({ data: DashboardQuickActionDTORuntype }),
        invalidates: ['GET /dashboard/preferences', 'GET /dashboard/quick-actions'],
    }),

    'DELETE /dashboard/quick-actions/:id': endpoint({
        description: 'Deletes an existing custom quick action for the logged-in user',
        pathParams: z.object({ id: z.string() }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ deleted: z.number() }),
        invalidates: ['GET /dashboard/preferences', 'GET /dashboard/quick-actions'],
    }),
};
